import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import { api } from '../../api/api';

interface Item {
  record_id: number;
  record_name: string;
  record_description: string;
  record_image_url: string;
  record_price: number;
  record_category: string;
}

const ItemView = () => {
  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<Item | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchItem = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/api/all/assets/${id}`);
        setItem(response.data);
      } catch (err: any) {
        setError(err.message || 'Failed to fetch item');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchItem();
    }
  }, [id]);

  if (loading) return <div className="text-white text-center py-10">Loading item...</div>;
  if (error) return <div className="text-red-500 text-center py-10">Error: {error}</div>;
  if (!item) return <div className="text-white text-center py-10">Item not found</div>;

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <Header />
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <div className="bg-gray-800 p-4 rounded-lg">
              <img src={item.record_image_url} alt={item.record_name} className="w-full h-auto rounded-lg" />
            </div>
            <div className="mt-8">
              <h2 className="text-2xl font-bold mb-4">Description</h2>
              <p className="text-gray-400">{item.record_description}</p>
            </div>
          </div>
          <div>
            <div className="bg-gray-800 p-4 rounded-lg">
              <h1 className="text-3xl font-bold">{item.record_name}</h1>
              <div className="text-yellow-400 text-2xl font-bold my-4">${item.record_price?.toFixed(2)}</div>
              <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full">Add to Cart</button>
              <div className="mt-4 text-sm text-gray-400">Delivery in 5 minutes</div>
            </div>
            <div className="bg-gray-800 p-4 rounded-lg mt-4">
              <h2 className="text-xl font-bold mb-4">Seller Information</h2>
              <div className="flex items-center">
                <img src="https://via.placeholder.com/50" alt="Seller Avatar" className="w-12 h-12 rounded-full" />
                <div className="ml-4">
                  <div className="font-bold">SellerName</div>
                  <div className="text-sm text-gray-400">100% Positive Feedback</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ItemView;